{
  "version": 1,
  "asset_id": "2e41472b-1042-42e7-af14-4e1350a0d1ab",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/2e41472b-1042-42e7-af14-4e1350a0d1ab/hero-new.jpg",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/2e41472b-1042-42e7-af14-4e1350a0d1ab/hero-new.jpg",
  "original_filename": "hero-new.jpg",
  "size": 241395,
  "content_type": "image/jpeg",
  "created_at": "2026-07-22T14:05:04Z"
}
